import useSWRMutation from "swr/mutation";
import { API_REST_METHODS, DEFAULT_LOCALE } from "../../../common/constants";
import { fetcher } from "../../../common/hooks";

export const useGetAnnouncementFilters = () => {
    const {
        data: announcementFilters = [],
        trigger: triggerGetAnnouncementFilters,
        isMutating: isLoadingAnnouncementFilters,
    } = useSWRMutation(
        "/api/notification-management/v1/announcement-filters",
        (url: string, { arg }: { arg: { locale?: string } }) =>
            fetcher(url, {
                options: {
                    method: API_REST_METHODS.GET,
                },
                locale: arg.locale || DEFAULT_LOCALE,
            })
    );

    return {
        announcementFilters,
        triggerGetAnnouncementFilters,
        isLoadingAnnouncementFilters,
    };
};
